/**
 * mimadita.com — Cart reserve timer
 * --------------------------------------------------------------------------
 * Powers the "Váš košík je rezervován pro 10:00 minut" countdown inside
 * the cart drawer. Loaded once per page from layout/theme.liquid (defer)
 * and survives Dawn's snippet innerHTML re-renders.
 *
 * Behavior:
 *  - First non-empty cart starts a 10-minute expiry timestamp in sessionStorage.
 *  - Persists across page loads in the same browser session.
 *  - Cart becomes empty (cart-drawer gets the .is-empty class) -> expiry cleared.
 *  - Browser session ends -> sessionStorage cleared by browser -> fresh timer next visit.
 *  - Each tick re-queries #cart-reserve-time so the snippet can be re-rendered freely.
 */
(function () {
  var KEY = 'md_cart_reserve_expires_at';
  var DURATION_MS = 10 * 60 * 1000;

  function readExpiry() {
    try { return parseInt(sessionStorage.getItem(KEY), 10) || 0; } catch (e) { return 0; }
  }
  function writeExpiry(ms) {
    try { sessionStorage.setItem(KEY, String(ms)); } catch (e) {}
  }
  function clearExpiry() {
    try { sessionStorage.removeItem(KEY); } catch (e) {}
  }

  function tick() {
    var drawer = document.querySelector('cart-drawer');
    if (drawer && drawer.classList.contains('is-empty')) {
      clearExpiry();
      return;
    }

    var el = document.getElementById('cart-reserve-time');
    if (!el) return; // No drawer rendered (e.g. notification cart) — nothing to do.

    var expiresAt = readExpiry();
    if (!expiresAt || expiresAt < Date.now()) {
      expiresAt = Date.now() + DURATION_MS;
      writeExpiry(expiresAt);
    }

    var remaining = Math.max(0, expiresAt - Date.now());
    var totalSec = Math.floor(remaining / 1000);
    var m = Math.floor(totalSec / 60);
    var s = totalSec % 60;
    el.textContent = m + ':' + (s < 10 ? '0' : '') + s;
  }

  // Run immediately so the visible 10:00 (or persisted value) updates ASAP,
  // then once per second for the page lifetime.
  tick();
  setInterval(tick, 1000);
})();
